<template>
  <router-link :to="href" class="link">
    <span class="link-dot"></span>
  </router-link>
</template>

<script>
export default {
  name: 'LinkButton',
  props: {
    href: {
      type: String,
      default: '#'
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/link.scss';
</style>
